import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetAvailableDevicesForInstallationRequest, IBaseGetByComanyRequest, IBaseGetByRevisionRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateDeviceCategoryRequest, IDeviceCategory, IUpdateDeviceCategoryRequest } from '../models/device-category';
import { ICreateDeviceLocationRequest, IDeviceLocation, IUpdateDeviceLocationRequest } from '../models/device-location';
import { ICreateDeviceRequest, IDevice, IDeviceDetailsResponse, IDeviceReduced, IExportDevicesRequest, IExportDevicesResponse, IGetDeviceByIdForRevision, IImportDevicesRequest, IImportDevicesResponse, ISearchDeviceRequest, IUpdateDeviceRequest } from '../models/device';
import { ICreateDeviceManufacturerRequest, IDeviceManufacturer, IUpdateDeviceManufacturerRequest } from '../models/device-manufacturer';
import { ICreateServiceRequest } from '../models/service';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http: HttpClient) { }

  // Device
  createDevice(request: ICreateDeviceRequest) {
    return this.http.post<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/devices/createDevice`,
      request
    )
  }

  getDevices(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IDeviceDetailsResponse[]>>(
      `${environment.baseUrl}/v1/devices/searchDevices`,
      request
    )
  }

  getDevicesByCompany(request: IBaseGetByComanyRequest){
    return this.http.post<IPagedResults<IDeviceDetailsResponse[]>>(
      `${environment.baseUrl}/v1/devices/searchDevicesByCompany`,
      request
    )
  }

  getDevicesByRevision(request: IBaseGetByRevisionRequest){
    return this.http.post<IPagedResults<IDeviceDetailsResponse[]>>(
      `${environment.baseUrl}/v1/devices/searchDevicesByRevision`,
      request
    )
  }

  getDevicesWithWearingPartsByRevision(request: IBaseGetByRevisionRequest){
    return this.http.post<IPagedResults<IDeviceDetailsResponse[]>>(
      `${environment.baseUrl}/v1/devices/searchDevicesWithWearingPartsByRevision`,
      request
    )
  }

  getAvailableDevicesForRevision(request: IBaseGetByRevisionRequest){
    return this.http.post<IPagedResults<IDeviceDetailsResponse[]>>(
      `${environment.baseUrl}/v1/devices/searchAvailableDevicesForRevision`,
      request
    )
  }

  getDevicesWithoutInstallationByCompany(request: IBaseGetAvailableDevicesForInstallationRequest){
    return this.http.post<IPagedResults<IDeviceReduced[]>>(
      `${environment.baseUrl}/v1/devices/searchDevicesWithoutInstallationByCompany`,
      request
    )
  }

  getDeviceById(id: string){
    return this.http.get<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/devices/getDevice/${id}`
    )
  }

  getDeviceForRevision(request: IGetDeviceByIdForRevision){
    return this.http.post<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/devices/getDeviceForRevision`,
      request
    )
  }

  updateDevice(request: IUpdateDeviceRequest){
    return this.http.put<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/devices/updateDevice/${request.id}`,
      request
    )
  }

  deleteDevice(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/devices/deleteDevice/${id}`
    )
  }

  importDevices(formData: FormData){
    return this.http.post<IImportDevicesResponse>(
      `${environment.baseUrl}/v1/devices/importDevices`,
      formData
    )
  }

  exportDevices(request: IExportDevicesRequest){
    return this.http.post<Blob>(
      `${environment.baseUrl}/v1/devices/exportDevices`,
      request,
      { 
        responseType: 'blob' as 'json',
        observe: 'response'
      } 
    )
  }




  // Note
  deleteNote(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/notes/deleteNote/${id}`
    )
  }


  

  // Service
  createService(request: ICreateServiceRequest) {
    return this.http.post<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/services/createService`,
      request
    )
  }

  deleteService(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/services/deleteService/${id}`
    )
  }



  // Device Category
  createDeviceCategory(request: ICreateDeviceCategoryRequest) {
    return this.http.post<IDeviceCategory>(
      `${environment.baseUrl}/v1/deviceCategories/createDeviceCategory`,
      request
    )
  }

  getAllDeviceCategories(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IDeviceCategory[]>>(
      `${environment.baseUrl}/v1/deviceCategories/getDeviceCategories`,
      request
    )
  }

  getDeviceCategoryById(id: string){
    return this.http.get<IDeviceCategory>(
      `${environment.baseUrl}/v1/deviceCategories/getDeviceCategory/${id}`
    )
  }

  updateDeviceCategory(request : IUpdateDeviceCategoryRequest){
    return this.http.put<IDeviceCategory>(
      `${environment.baseUrl}/v1/deviceCategories/updateDeviceCategory/${request.id}`,
      request
    )
  }

  deleteDeviceCategory(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/deviceCategories/deleteDeviceCategory/${id}`
    )
  }




  // Device Location
  createDeviceLocation(request: ICreateDeviceLocationRequest) {
    return this.http.post<IDeviceLocation>(
      `${environment.baseUrl}/v1/deviceLocations/createDeviceLocation`,
      request
    )
  }
  
  getDeviceLocationsByCompany(request: IBaseGetByComanyRequest){
    return this.http.post<IPagedResults<IDeviceLocation[]>>(
      `${environment.baseUrl}/v1/deviceLocations/getDeviceLocations`,
      request
    )
  }

  updateDeviceLocation(request : IUpdateDeviceLocationRequest){
    return this.http.put<IDeviceLocation>(
      `${environment.baseUrl}/v1/deviceLocations/updateDeviceLocation/${request.id}`,
      request
    )
  }

  deleteDeviceLocation(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/deviceLocations/deleteDeviceLocation/${id}`
    )
  }




  // Device Manufacturer
  createDeviceManufacturer(request: ICreateDeviceManufacturerRequest) {
    return this.http.post<IDeviceManufacturer>(
      `${environment.baseUrl}/v1/deviceManufacturers/createDeviceManufacturer`,
      request
    )
  }

  getDeviceManufacturers(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IDeviceManufacturer[]>>(
      `${environment.baseUrl}/v1/deviceManufacturers/getDeviceManufacturers`,
      request
    )
  }

  updateDeviceManufacturer(request : IUpdateDeviceManufacturerRequest){
    return this.http.put<IDeviceManufacturer>(
      `${environment.baseUrl}/v1/deviceManufacturers/updateDeviceManufacturer/${request.id}`,
      request
    )
  }

  deleteDeviceManufacturer(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/deviceManufacturers/deleteDeviceManufacturer/${id}`
    )
  }
}
